import { getConfig, URLS } from '@constants';

import { ESubProject } from '@enums';

import { RouterSwitch } from '@components/RouterSwitch';

import {
	Brand,
	Dmca,
	Landing,
	ShareAlbum,
	ShareArtist,
	SharePlaylist,
	ShareTrack,
	ShareUser,
} from './containers';

import { IRouteConfigComponent } from '@interfaces';

const ROUTES_BOOM: IRouteConfigComponent[] = [
	{
		path: URLS.BOOM_BRAND,
		component: Brand,
		exact: true,
	},
	{
		path: URLS.BOOM_DMCA,
		component: Dmca,
		exact: true,
	},
	{
		path: URLS.BOOM_MAIN,
		component: Landing,
		exact: true,
	},
];

const ROUTES_SHARE: IRouteConfigComponent[] = [
	{
		path: URLS.SHARE_ALBUM,
		component: ShareAlbum,
	},
	{
		path: URLS.SHARE_ARTIST,
		component: ShareArtist,
	},
	{
		path: URLS.SHARE_PLAYLIST,
		component: SharePlaylist,
	},
	{
		path: URLS.SHARE_TRACK,
		component: ShareTrack,
	},
	{
		path: URLS.SHARE_USER,
		component: ShareUser,
	},
];

export const getRoutes = () => {
	const { subProject } = getConfig();

	switch (subProject) {
		case ESubProject.BOOM:
			return ROUTES_BOOM;
		case ESubProject.SHARE:
			return ROUTES_SHARE;
		default:
			return [];
	}
};

export const getRouter = () => {
	// eslint-disable-next-line new-cap
	return RouterSwitch(getRoutes());
};
